// extracted by mini-css-extract-plugin
export var active = "s-module--active--d3420";
export var big = "s-module--big--9508a";
export var optionList = "s-module--optionList--0fd99";
export var optionsContainer = "s-module--optionsContainer--fa5a6";
export var selectContainer = "s-module--selectContainer--28340";
export var selected = "s-module--selected--1ef26";
export var selectedHolder = "s-module--selectedHolder--47811";